import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useApp } from "@/context/AppContext";

export default function Splash() {
  const navigate = useNavigate();
  const { user, isGuest } = useApp();

  useEffect(() => {
    const t = setTimeout(() => navigate(user || isGuest ? "/home" : "/auth", { replace: true }), 3000);
    return () => clearTimeout(t);
  }, [navigate, user, isGuest]);

  return (
    <div
      data-testid="splash-screen"
      onClick={() => navigate(user || isGuest ? "/home" : "/auth", { replace: true })}
      className="relative h-full w-full flex items-center justify-center overflow-hidden bg-[#f4f8ee]"
    >
      <img
        data-testid="splash-image"
        src="/images/splash.png"
        alt="Welcome to U&URS NUTRITIONIST"
        className="w-full h-full object-contain"
      />
    </div>
  );
}
